export let DocumentalValidationCode = /*#__PURE__*/function (DocumentalValidationCode) {
  DocumentalValidationCode[DocumentalValidationCode["NONE"] = 1] = "NONE";
  DocumentalValidationCode[DocumentalValidationCode["ANY"] = 2] = "ANY";
  DocumentalValidationCode[DocumentalValidationCode["ALL"] = 3] = "ALL";
  return DocumentalValidationCode;
}({});
export let DocumentalGroupValidationCode = /*#__PURE__*/function (DocumentalGroupValidationCode) {
  DocumentalGroupValidationCode[DocumentalGroupValidationCode["NO"] = 1] = "NO";
  DocumentalGroupValidationCode[DocumentalGroupValidationCode["YES"] = 2] = "YES";
  return DocumentalGroupValidationCode;
}({});
export let DocumentalValidationPersonalizationCode = /*#__PURE__*/function (DocumentalValidationPersonalizationCode) {
  DocumentalValidationPersonalizationCode[DocumentalValidationPersonalizationCode["NO"] = 1] = "NO";
  DocumentalValidationPersonalizationCode[DocumentalValidationPersonalizationCode["YES"] = 2] = "YES";
  return DocumentalValidationPersonalizationCode;
}({});
export let DocumentalIgnoredCode = /*#__PURE__*/function (DocumentalIgnoredCode) {
  DocumentalIgnoredCode[DocumentalIgnoredCode["NOT_IGNORED"] = 1] = "NOT_IGNORED";
  DocumentalIgnoredCode[DocumentalIgnoredCode["IGNORED"] = 2] = "IGNORED";
  return DocumentalIgnoredCode;
}({});
export let DocumentalValidationLineStatus = /*#__PURE__*/function (DocumentalValidationLineStatus) {
  DocumentalValidationLineStatus[DocumentalValidationLineStatus["GROUP_STATE_WITHOUT_VALIDATION"] = 1] = "GROUP_STATE_WITHOUT_VALIDATION";
  DocumentalValidationLineStatus[DocumentalValidationLineStatus["GROUP_STATE_VALIDATION_VALIDATED"] = 2] = "GROUP_STATE_VALIDATION_VALIDATED";
  DocumentalValidationLineStatus[DocumentalValidationLineStatus["GROUP_STATE_VALIDATION_NOT_VALIDATED"] = 3] = "GROUP_STATE_VALIDATION_NOT_VALIDATED";
  return DocumentalValidationLineStatus;
}({});
export let DocumentalValidationStatisticsResult = /*#__PURE__*/function (DocumentalValidationStatisticsResult) {
  DocumentalValidationStatisticsResult[DocumentalValidationStatisticsResult["NO_INFO"] = 0] = "NO_INFO";
  DocumentalValidationStatisticsResult[DocumentalValidationStatisticsResult["IN_PROGRESS"] = 1] = "IN_PROGRESS";
  DocumentalValidationStatisticsResult[DocumentalValidationStatisticsResult["WAIT_SECOND_LEVEL"] = 2] = "WAIT_SECOND_LEVEL";
  DocumentalValidationStatisticsResult[DocumentalValidationStatisticsResult["VALID"] = 3] = "VALID";
  return DocumentalValidationStatisticsResult;
}({});
export let DocumentalTypologyResult = /*#__PURE__*/function (DocumentalTypologyResult) {
  DocumentalTypologyResult[DocumentalTypologyResult["TYPOLOGY_RESULT_NO_INFO"] = 0] = "TYPOLOGY_RESULT_NO_INFO";
  DocumentalTypologyResult[DocumentalTypologyResult["TYPOLOGY_RESULT_VALID"] = 1] = "TYPOLOGY_RESULT_VALID";
  DocumentalTypologyResult[DocumentalTypologyResult["TYPOLOGY_RESULT_INVALID"] = 2] = "TYPOLOGY_RESULT_INVALID";
  DocumentalTypologyResult[DocumentalTypologyResult["TYPOLOGY_RESULT_IN_PROGRESS"] = 3] = "TYPOLOGY_RESULT_IN_PROGRESS";
  return DocumentalTypologyResult;
}({});
export let DocumentRequestStatus = /*#__PURE__*/function (DocumentRequestStatus) {
  DocumentRequestStatus["RAFT_STATUS"] = "0";
  DocumentRequestStatus["IN_PROGRESS_STATUS"] = "1";
  DocumentRequestStatus["COMPLETED_STATUS"] = "2";
  DocumentRequestStatus["CANCELED_STATUS"] = "3";
  return DocumentRequestStatus;
}({});